import React, { useReducer } from 'react'
import history from "../../routes/history";

import axios from 'axios'

export const AuthDataContext = React.createContext()

const baseURL = process.env.REACT_APP_BASE_URL

export const loginURL = process.env.REACT_APP_LOGIN_URL

export const signupURL = process.env.REACT_APP_SIGNUP_URL

export const authInstance = axios.create({
    baseURL: baseURL,
    timeout: 100000,
    headers: {
        'Authorization': "JWT " + localStorage.getItem('access_token'),
        'Content-Type': 'application/json',
        'accept': 'application/json'
    }
});

authInstance.interceptors.response.use(
    response => response,
    error => {
        const originalRequest = error.config;

        if (error.response.status === 401 &&
            error.response.data.code === "user_inactive") 
            {
                localStorage.clear();
                authInstance.defaults.headers['Authorization'] = "JWT "
                window.location.href = loginURL
        }

        if (error.response.status === 401 &&
            error.response.data.code === "token_not_valid" &&
            originalRequest.url !== '/auth/token/refresh/') 
            {
                const refreshToken = localStorage.getItem('refresh_token');

                if (refreshToken){
                    const tokenParts = JSON.parse(atob(refreshToken.split('.')[1]));

                    // exp date in token is expressed in seconds, while now() returns milliseconds:
                    const now = Math.ceil(Date.now() / 1000);

                    if (tokenParts.exp > now) {
                        return authInstance
                        .post('/auth/token/refresh/', {refresh: refreshToken})
                        .then((response) => {
                            
                            localStorage.setItem('access_token', response.data.access);
                            localStorage.setItem('refresh_token', response.data.refresh);
            
                            authInstance.defaults.headers['Authorization'] = "JWT " + response.data.access;
                            originalRequest.headers['Authorization'] = "JWT " + response.data.access;
            
                            return authInstance(originalRequest);
                        })
                        .catch(err => {
                            console.log(err)
                            localStorage.clear();
                            authInstance.defaults.headers['Authorization'] = "JWT "
                            window.location.href = loginURL
                        });
                    }else{
                        console.log("Refresh token is expired", tokenParts.exp, now);
                        localStorage.clear();
                        authInstance.defaults.headers['Authorization'] = "JWT "
                        window.location.href = loginURL
                    }
                }else{
                    console.log("Refresh token not available.")
                    return Promise.reject(error);
                }
        }
        return Promise.reject(error);
  }
);

const authState = {
    email: '',
    first_name: '',
    last_name: '',
    job_title: '',
    company: '',
    site_name: '',
    street_1: '',
    street_2: '',
    city: '',
    st_1: '',
    country: '',
    postal_code: '',
    phone_number: '',
    manufactureTerms: '',
    shippingTerms: '',
    paymentTerms: '',
    scope: '',
    validity: '',
    conditionsOfSale: '',
    POAddress: '',
    cancellation: '',
    forceMajeure: '',
    confidentiality: '',
    error: '',
    authenticated: false,
    staff: false,
    hasProfile: false,
    is_approved: false,
    is_reviewed: false,
    validErrors: {}
}

const reducer = (state, action) => {
    switch (action.type) {
        case "change":
            const id = action.name
            const value = action.value

            return {...state, [id]: value};
        case "bulkChange":
            const newBState = action.changes

            return {...state, ...newBState};
        case "logout":
            localStorage.clear();
            authInstance.defaults.headers['Authorization'] = "JWT "

            history.push("/")

            return{...authState};
        case "processUser":
            const data = action.data
            const newState = authState

            Object.entries(newState).forEach(([key, label]) => {
                if(data[key]){
                    newState[key] = data[key]
                }
            })

            newState['authenticated'] = true

            return{...newState};
        default:
            return{...state};
    }
}

export const AuthProvider = (props) => {
    const initialState = authState;

    const [authData, dispatch] = useReducer(reducer, initialState)

    const value = {authData, dispatch}

    return <AuthDataContext.Provider value={value}>{props.children}</AuthDataContext.Provider>
}